module.exports = __webpack_public_path__ + "img/icon_button_klimat.07b28bdb.svg";